module.exports = __webpack_public_path__ + "img/xiaochengxu.e4adc93b.jpeg";